import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
// import UserContext from './components/wrappers/UserContext'
import ProcessContext from './components/wrappers/ProcessContext'
import ParameterContext from './components/wrappers/ParameterContext'
import NoteContext from './components/wrappers/NoteContext'
import CurrentProcessContext from './components/wrappers/CurrentProcessContext'
import Login from './components/features/landing/Login'
import ProcessSelection from './components/features/landing/ProcessSelection'
import ProcessPage from './components/features/processPage/ProcessPage'
import Header from './components/elem/Header'
import { Toast as ToastContainer } from './components/elem/Toast'
import APIRequestContextProvider from './components/wrappers/APIRequestWithToken'
import FilterContextProvider from './components/wrappers/FilterContext'

const App = () => (
    <React.Fragment>
        <Header />
        <div className="pageContent">
            <Router>
                <Switch>
                    <APIRequestContextProvider>
                        {/* <UserContext> */}
                        <ProcessContext>
                            <ParameterContext>
                                <Route
                                    exact
                                    path="/"
                                    component={ProcessSelection}
                                />
                                <Route exact path="/:processName">
                                    <CurrentProcessContext>
                                        <NoteContext>
                                            <FilterContextProvider>
                                                <ProcessPage />
                                            </FilterContextProvider>
                                        </NoteContext>
                                    </CurrentProcessContext>
                                </Route>
                            </ParameterContext>
                        </ProcessContext>
                        <Route path="/login" component={Login} />
                        {/* </UserContext> */}
                    </APIRequestContextProvider>
                </Switch>
            </Router>
        </div>
        <ToastContainer />
    </React.Fragment>
)

export default App
